import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import './index.css'
import App from './App.tsx'
import { AppCrashFallback } from './components/AppCrashFallback'
import { QUERY } from './config/constants'
import { ErrorBoundary } from './lib/error-boundary'
import { initSentry } from './lib/sentry'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: QUERY.STALE_TIME_MS, retry: QUERY.RETRY_COUNT },
  },
})

// Sentry init — async because the SDK is dynamic-imported (separate chunk).
// When VITE_SENTRY_ENABLED!=='true' it returns immediately and the chunk
// is never fetched. We await before render so any startup error in App
// propagates to Sentry.
await initSentry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<AppCrashFallback />}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
